import React from "react";
import { useTranslation } from "react-i18next";

import Navigation from "../../Components/Navigation/Navigation";
import Home from "../../sections/Home/Home";
import About from "../../sections/About/About";
import Services from "../../sections/OurServices/Services";
import ProptechClub from "../../sections/OurEvent/Event";
import Blogs from "../../sections/Blogs/Blogs";
import Form from "../../Components/Form/Form";
import Footer from "../../Components/Footer/Footer";

const HomePage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navigation
        navItems={[
          {
            label: t("navigation.about"),
            sectionId: "about_section",
          },
          {
            label: t("navigation.services"),
            sectionId: "service_section",
          },
          {
            label: t("navigation.blogs"),
            sectionId: "blogs_section",
          },
          {
            label: t("navigation.club"),
            sectionId: "club_section",
          },
          {
            label: t("navigation.contact"),
            sectionId: "form_section",
          },
        ]}
      />
      <Home />
      <About />
      <Services />
      <ProptechClub />
      <Blogs />
      <Form />
      <Footer />
    </>
  );
};

export default HomePage;
